<template>
  <v-row>
    <v-col>
      <Table
        :items="items"
        :headers="allHeaders"
        :openDialog="openDialog"
        @headersUpdated="updateHeaders"
        class="mx-2"
        @refreshItems="refreshItems"
        :showRefresh="true"
      />
      <v-dialog
        v-model="open"
        max-width="500px"
        persistent
        @keydown.esc="reset(false)"
      >
        <Form
          :items="dataInputs"
          :itemsCheckbox="dataCheckboxes"
          @save="saveForm"
          @cancel="reset"
          :maxWidth="maxWidth[0]"
          :mode="mode"
          :show="true"
        />
      </v-dialog>
      <DeleteDialog
        :showDialog="openDelete"
        :title="titleDelete"
        :confirmDelete="deleteItem"
        :cancelDelete="cancelDelete"
      />
    </v-col>
    <v-dialog v-model="isLoading" class="dialog__loader" :overlay-opacity="0.3">
      <Loader :loading="isLoading" />
    </v-dialog>
    <Snackbar :alert="alert" :color="color" :textAlert="textAlert" />
  </v-row>
</template>
<script>
import Table from "@/components/Complement/TableWithSearch";
import Form from "@/components/Complement/Form";
import DeleteDialog from "@/components/Complement/DeleteDialog.vue";
import Snackbar from "@/components/Complement/Snackbar.vue";
import Loader from "@/components/Complement/Loader.vue";
import modelsLiquidation from "@/store/modelosDeLiquidacion/modelsLiquidation";
import adjustmenRule from "@/models/modelosDeLiquidacion/Relations/adjustmenRule";
import date from "@/store/common/date";
import configTable from "@/store/configuracionDeTablas/configTable.js";

export default {
  components: {
    Table,
    Form,
    DeleteDialog,
    Snackbar,
    Loader,
  },
  data() {
    return {
      title: this.$tc("modelsLiquidations.rulesAdjusment"),
      titleTable: "ModelosDeLiquidacion_ReglasDeAjustes",
      titleDelete: this.$tc("modelsLiquidations.toRuleAdjustmentLiquidation"),
      isLoading: true,
      maxWidth: ["500px", "500px", "400px"],
      color: "#82A1D0",
      alert: false,
      textAlert: "",
      oldItems: null,
      headers: [
        {
          text: "Procedimiento",
          value: "nameProcedure",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Descripción",
          value: "description",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Orden",
          value: "order",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Activa",
          value: "active",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Acciones",
          value: "actions",
          class: "primary secondary--text",
          sortable: false,
          visible: true,
          width: "100px",
        },
      ],
      dataInputs: [
        {
          name: "nameProcedure",
          label: "Nombre de la regla  ajuste",
          data: "",
          type: "text",
          rules: [
            (v) => !!v || this.$tc("editRegistrations.requerid"),
            (v) =>
              v.length <= 50 || this.$tc("costCenter.rulesDataName50chart"),
          ],
        },

        {
          name: "description",
          label: "Descripcion",
          data: "",
          type: "text",
          rules: [
            (v) => !!v || this.$tc("editRegistrations.requerid"),
            (v) =>
              v.length <= 100 || this.$tc("costCenter.rulesDataName50chart"),
          ],
        },
        {
          name: "order",
          label: "Orden",
          data: "",
          type: "Number",
          rules: [
            (v) => !!v || this.$tc("validation.required"),
            (v) => v >= 1 || this.$tc("validation.greaterThanZero"),
            (v) =>
              v < 10000000 || `${this.$t("validation.maxDigits", { max: 7 })}`,
          ],
        },
      ],
      dataCheckboxes: [
        {
          name: "activa",
          label: "Activa",
          data: false,
        },
      ],
    };
  },
  computed: {
    allHeaders() {
      return configTable.state.colums;
    },
    items() {
      if (!modelsLiquidation.state.edit.reglasAjuste) {
        return [];
      }

      if (modelsLiquidation.state.edit.reglasAjuste.length === 0) {
        return [];
      } else {
        return modelsLiquidation.state.edit.reglasAjuste.map((item) => {
          return adjustmenRule.fromJson(item);
        });
      }
    },

    mode: {
      get() {
        return modelsLiquidation.state.modeFormRelation;
      },
      set(newValue) {
        return newValue;
      },
    },
    open: {
      get() {
        return modelsLiquidation.state.openFormRelation;
      },
      set(newvalue) {
        return newvalue;
      },
    },
    openDelete: {
      get() {
        return modelsLiquidation.state.openDelete;
      },
      set(newvalue) {
        return newvalue;
      },
    },
  },
  async mounted() {
    configTable.commit("setColums", []);
    let nameTable = this.titleTable;
    configTable
      .dispatch("getColumsTableName", nameTable)
      .then(() => {
        if (configTable.state.colums.length === 0 || configTable.state.colums.length !== this.headers.length ) {
          this.saveConfigColumns();
        }
      })
      .catch((error) => {
        console.error("Error occurred:", error);
      });
    this.isLoading = false;
  },
  methods: {
    async refreshItems() {
      if (modelsLiquidation.state.edit.id) {
        await modelsLiquidation.dispatch(
          "getLiquidationModelId",
          modelsLiquidation.state.edit.id
        );
      }
    },
    updateHeaders(headers) {
      const updatedColums = headers;
      configTable.commit("setColums", updatedColums);
      this.saveConfigColumns();
    },
    saveConfigColumns() {
      let columnsToSave = configTable.state.colums;
      if (columnsToSave === undefined || this.allHeaders.length !== this.headers.length  || columnsToSave.length === 0) {
        columnsToSave = this.headers;
      }

      const configData = {
        operId: Number(localStorage.getItem("operId")),
        nameTable: this.titleTable,
        json: JSON.stringify(columnsToSave),
      };
      configTable.commit("setNew", configData);
      configTable.dispatch("new").then(() => {
        configTable.commit("setNew", []);
      });
    },
    showAlert(text, color) {
      this.alert = true;
      this.textAlert = text;
      this.color = color;

      setTimeout(() => {
        this.alert = false;
      }, 3000);
    },

    addRuleAdjustment(form) {
      let payload = form;
      payload.liqModeloId = modelsLiquidation.state.edit.id;
      modelsLiquidation.commit("setNew", payload);
      modelsLiquidation
        .dispatch("addRuleAdjustment")
        .then(() => {
          this.showAlert(
            this.$tc(
              "modelsLiquidations.addRuleAdjustmentToLiquidationSuccess"
            ),
            "#82A1D0"
          );
          this.reset(false);
        })
        .catch((error) => {
          if (error.response && error.response.status === 406) {
            this.showAlert(
              this.$tc("modelsLiquidations.errorEmployee406"),
              "#ff8d58"
            );
          } else {
            this.showAlert(
              this.$tc("modelsLiquidations.errorEmployee"),
              "#ff8d58"
            );
          }
          this.reset(false);
          reject(error);
        });
    },

    editRuleAdjustment(form) {
      let payload = this.detectChanges(form);
      if (Object.keys(payload).length > 0) {
        payload.liqModeloId = modelsLiquidation.state.edit.id;
        payload.orderOld = this.oldItems.order;
        payload.itemsForm = form;
        payload.id = this.oldItems.id;

        modelsLiquidation.commit("setEditRelation", payload);
        modelsLiquidation
          .dispatch("editRuleAdjustment")
          .then(() => {
            this.showAlert(
              this.$tc(
                "modelsLiquidations.editRuleAdjustmentToLiquidationSuccess"
              ),
              "#82A1D0"
            );
          })
          .catch((error) => {
            if (error.response && error.response.status === 406) {
              this.showAlert(
                this.$tc("modelsLiquidations.errorEmployee406"),
                "#ff8d58"
              );
            } else {
              this.showAlert(
                this.$tc("modelsLiquidations.errorEmployee"),
                "#ff8d58"
              );
            }
            this.reset(false);
            reject(error);
          });
      } else {
        this.showAlert(this.$tc("validation.noEditsMessage"), "#F7DC6F");
      }

      this.reset(false);
    },
    detectChanges(newItems) {
      newItems.activa = newItems.activa === "true" ? true : false;

      const changes = {};
      const oldItem = this.oldItems;

      if (oldItem) {
        if (oldItem.order !== Number(newItems.order)) {
          changes.order = newItems.order;
        }

        if (oldItem.nameProcedure !== newItems.nameProcedure) {
          changes.nameProcedure = newItems.nameProcedure;
        }

        if (oldItem.description !== newItems.description) {
          changes.description = newItems.description;
        }

        if (oldItem.activeTable !== newItems.activa) {
          changes.activa = newItems.activa;
        }
      }

      return changes;
    },
    async openDialog(type, item) {
      this.typeForm = type;

      switch (this.typeForm) {
        case "add":
          this.dataInputs[2].readonly = false;
          modelsLiquidation.commit(
            "setModeFormRelation",
            this.$tc("modelsLiquidations.addRuleAdjusmentToLiquidation")
          );
          modelsLiquidation.commit("setOpenFormRelation", true);
          break;
        case "edit":
          this.itemId = item.id;
          this.oldItems = item;
          await this.setEdit(item);
          modelsLiquidation.commit(
            "setModeFormRelation",
            this.$tc("modelsLiquidations.editRuleAdjustmentToLiquidation")
          );
          modelsLiquidation.commit("setOpenFormRelation", true);
          break;
        case "delete":
          modelsLiquidation.commit("setOpenDelete", true);
          this.itemToDelete = {
            ...item,
            liqModeloId: modelsLiquidation.state.edit.id,
          };
          break;

        default:
          break;
      }
    },
    setEdit(item) {
      this.dataInputs[0].data = item.nameProcedure;
      this.dataInputs[1].data = item.description;
      this.dataInputs[2].data = item.order;
      this.dataInputs[2].readonly = false;
      this.dataCheckboxes[0].data = item.activeTable;
    },

    resetDate() {
      const day = new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10);
      date.commit("setDateFrom", day);
      date.commit("setDateTo", null);
    },

    reset(value) {
      this.resetDate();
      modelsLiquidation.commit("setOpenFormRelation", value);
      this.dataInputs.forEach((item) => {
        item.data = "";
      });
    },

    saveForm(items) {
      switch (this.typeForm) {
        case "add":
          this.addRuleAdjustment(items);
          break;
        case "edit":
          this.editRuleAdjustment(items);
          break;
        default:
          break;
      }
    },

    deleteItem() {
      modelsLiquidation.commit("setItemDelete", this.itemToDelete);
      modelsLiquidation
        .dispatch("deleteRuleAdjustment")
        .then(() => {
          this.openDelete = false;
          modelsLiquidation.commit("setOpenDelete", false);
          this.showAlert(
            this.$tc(
              "modelsLiquidations.deleteRuleAdjustmentToLiquidationSuccess"
            ),
            "#82A1D0"
          );
        })
        .catch((e) => {
          this.showAlert(
            this.$tc("modelsLiquidations.errorRuleAdjustment"),
            "#ff8d58"
          );
        });
    },

    cancelDelete() {
      this.openDelete = false;
      modelsLiquidation.commit("setOpenDelete", false);
    },
  },
};
</script>
